'use client';

import { classNames } from "../../../utils/styles/classNames.js";
import { buttonVariant, buttonStatus, buttonHover, button } from "../MenuItem.css.js";
import { defaultProps } from "../MenuItem.defaultProps.js";
const getButtonProps = ({
  disabled,
  variant,
  active
}) => {
  const restStatus = active ? "active" : "default";
  return {
    className: classNames(
      button,
      !disabled && buttonHover[variant || defaultProps.variant],
      buttonStatus[disabled ? "disabled" : restStatus],
      buttonVariant[variant || defaultProps.variant]
    )
  };
};
export {
  getButtonProps
};
